import article from './sections/article';
import articles from './sections/articles';
import newsletter from './sections/newsletter';

const translations = {
    page: {
        metaTitle: 'Artykuły',
        metaDescription: 'Artykuły',
    },
    sections: {
        article,
        articles,
        newsletter,
    },
};

export default translations;
